import React from 'react';

import type { CollectionEntity } from 'collections/types';
import type { ColumnRenderers } from 'components/common/EntityDataTable';

import TitleCell from './cells/TitleCell';
import OwnersCell from './cells/OwnersCell';
import TypeCell from './cells/TypeCell';

const customColumnRenderers: ColumnRenderers<CollectionEntity> = {
  attributes: {
    name: {
      renderCell: (name: CollectionEntity['name'], collectionEntity: CollectionEntity) => (
        <TitleCell name={name} id={collectionEntity.id} type={collectionEntity.type} />
      ),
    },
    owners: {
      renderCell: (owners: CollectionEntity['owners']) => <OwnersCell owners={owners} />,
    },
    type: {
      renderCell: (type: CollectionEntity['type']) => <TypeCell type={type} />,
    },
  },
};

export default customColumnRenderers;
